module.exports = __webpack_public_path__ + "02_face.53f50ab0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer1/02_face.png
// module id = DUq+
// module chunks = 0